import styled from 'styled-components';

import { config } from '_config';
import { theme } from '_constants/theme';

import Card from '_components/atomic/layouts/Card';

const StyledOuterContainer = styled.div`
  max-width: ${theme.spaces.large23X * 10 + 10}px;
  width: 100%;
`;

const StyledInnerContainer = styled.div`
  padding-top: ${theme.spaces.large6X}px;
  padding-bottom: ${theme.spaces.large6X}px;
  padding-left: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.regular}px;
`;

const TermsSection = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Card.Text
          size={theme.fontSizes.large2X}
          weight={600}
          bottomSpace={theme.spaces.large}
          desktop
        >
          Terms of Service
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.large}
          weight={600}
          bottomSpace={theme.spaces.large}
          mobile
        >
          Terms of Service
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          1. Acceptance of Terms
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Welcome to Incorpified. By accessing or using our services, you agree
          to comply with and be bound by these Terms of Service. If you do not
          agree to these terms, please do not use our services.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          2. Modifications to Terms
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Incorpified reserves the right to update or change these Terms at any
          time without prior notice. Any modifications will be posted on this
          page, and the &quot;Last Updated&quot; date will be revised. Your
          continued use of the service after any changes constitutes acceptance
          of the new terms.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          3. Description of Service
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Incorpified provides a range of business formation services, including
          but not limited to the formation of LLCs, corporations, and other
          business entities, document preparation and filing, registered agent
          services, and additional business support services. Our services are
          designed to help you comply with the legal requirements for forming
          and maintaining a business entity.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          4. Eligibility
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          To use our services, you must be at least 18 years of age. By using
          our services, you represent and warrant that you meet this
          requirement.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          5. User Responsibilities
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          5.1 Accurate Information
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          You agree to provide accurate, current, and complete information
          during the registration process and whenever required in the course of
          using our services. Failure to do so may result in the suspension or
          termination of your account and services.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          5.2 Account Security
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          You are responsible for maintaining the confidentiality of your
          account credentials and for all activities that occur under your
          account. You agree to notify us immediately of any unauthorized use of
          your account.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          6. Fees and Payments
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          6.1 Service Fees
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Fees for our services are listed on our website and are subject to
          change. All fees are non-refundable unless stated otherwise in our
          Refund Policy.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          6.2 Payment Methods
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          We accept various forms of payment, including credit cards and other
          payment methods listed on our website. By providing a payment method,
          you authorize us to charge all fees incurred through your account to
          the designated payment method.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          6.3 Billing Disputes
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          If you believe there is an error in billing, you must contact us
          within 30 days of the billing date. We will investigate and attempt to
          resolve any disputes.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          7. Refund Policy
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Our refund policy is detailed on our website. Requests for refunds
          must be made in accordance with the procedures and within the time
          frames specified in the refund policy.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          8. Intellectual Property
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          8.1 Ownership
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          All content on the Incorpified website, including but not limited to
          text, graphics, logos, and software, is the property of Incorpified or
          its licensors and is protected by intellectual property laws.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          8.2 Limited License
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Incorpified grants you a limited, non-exclusive, non-transferable
          license to access and use the website and services for personal or
          internal business use. This license does not include any resale or
          commercial use of the website or its contents.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          9. Privacy Policy
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Our Privacy Policy, which explains how we collect, use, and protect
          your information, is incorporated into these Terms by reference.
          Please review our Privacy Policy for more details.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          10. Third-Party Services
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          10.1 Links to Third-Party Websites
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Our website may contain links to third-party websites or services that
          are not owned or controlled by Incorpified. We have no control over,
          and assume no responsibility for, the content, privacy policies, or
          practices of any third-party websites or services.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          10.2 Third-Party Service Providers
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          We may use third-party service providers to perform certain services
          on our behalf, including payment processing, data analysis, and
          marketing. These service providers are required to maintain the
          confidentiality of your information and are prohibited from using it
          for any other purpose.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          11. Limitation of Liability
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          11.1 Disclaimer of Warranties
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Incorpified provides its services &quot;as is&quot; and &quot;as
          available&quot; without any warranties, either express or implied. We
          do not warrant that our services will be uninterrupted, error-free, or
          completely secure.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          11.2 Limitation of Liability
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          To the fullest extent permitted by law, Incorpified will not be liable
          for any indirect, incidental, special, consequential, or punitive
          damages, or any loss of profits or revenues, whether incurred directly
          or indirectly, or any loss of data, use, goodwill, or other intangible
          losses, resulting from (a) your use or inability to use the services;
          (b) any unauthorized access to or use of our servers and/or any
          personal information stored therein; (c) any interruption or cessation
          of transmission to or from our services; (d) any bugs, viruses, trojan
          horses, or the like that may be transmitted to or through our services
          by any third party; or (e) any errors or omissions in any content or
          for any loss or damage incurred as a result of the use of any content
          posted, emailed, transmitted, or otherwise made available through the
          services.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          11.3 Cap on Liability
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          In no event shall Incorpified’s total liability to you for all claims
          arising out of or relating to these terms or the use or inability to
          use the services exceed the amount you paid to Incorpified for the
          services.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          12. Indemnification
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          You agree to indemnify, defend, and hold harmless Incorpified, its
          affiliates, and their respective officers, directors, employees, and
          agents from and against any and all claims, damages, obligations,
          losses, liabilities, costs, or debt, and expenses (including but not
          limited to attorney’s fees) arising from: (a) your use of and access
          to the services; (b) your violation of any term of these terms; (c)
          your violation of any third-party right, including without limitation
          any copyright, property, or privacy right; or (d) any claim that your
          use of the services caused damage to a third party.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          13. Governing Law
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          These Terms are governed by and construed in accordance with the laws
          of the state in which Incorpified operates, without regard to its
          conflict of law principles.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          14. Dispute Resolution
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          14.1 Arbitration
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Any disputes arising out of or relating to these Terms or our services
          will be resolved through binding arbitration in accordance with the
          rules of the American Arbitration Association. The arbitration will
          take place in the state in which Incorpified operates, and the
          arbitrator&apos;s decision will be binding and may be entered as a
          judgment in any court of competent jurisdiction.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          14.2 Class Action Waiver
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          You agree that any arbitration or proceeding will be limited to the
          dispute between you and Incorpified individually. You acknowledge and
          agree that you waive the right to participate as a plaintiff or class
          member in any purported class action, collective action, or
          representative proceeding.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          15. Contact Information
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          For any questions or concerns about these Terms, please contact us
          at&nbsp;<a href={`mailto:${config.email}`}>{config.email}</a>.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          16. Entire Agreement
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          These Terms constitute the entire agreement between you and
          Incorpified regarding the use of our services and supersede all prior
          agreements and understandings.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          17. Severability
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          If any provision of these Terms is found to be invalid or
          unenforceable, the remaining provisions will remain in full force and
          effect.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.regular}
          weight={700}
          bottomSpace={theme.spaces.regular}
        >
          18. Waiver
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          The failure of Incorpified to enforce any right or provision of these
          Terms will not be deemed a waiver of such right or provision.
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          These Terms were last updated on 05/15/2024
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.small}
          weight={400}
          bottomSpace={theme.spaces.regular}
        >
          Thank you for choosing Incorpified for your business formation needs.
        </Card.Text>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default TermsSection;
